/* global k, firebase */
import { utils as xlsxUtils } from 'xlsx';
import { SheetFromArrayOfObjects } from '../modules/ExportFunctions.js';

export function AttributeToString(attributeData, attributeModel, options) {
  options = options || {};
  attributeModel = attributeModel || {};
  if (attributeModel.gui_element == 'pole_tag') {
    let value = '';
    if (options.includeCompany) {
      value = attributeData.company || options.noCompanyDefault || 'Unknown';
      if (value) value += ': ';
    }
    value += attributeData.tagtext || options.noTagDefault || 'No Tag';
    return value;
  } else if (attributeModel.gui_element == 'table') {
    let csvString = '';
    let headers = [];
    let rows = [];

    // iterate over each table row
    for (let key in attributeData) {
      let data = attributeData[key];
      let rowData = {};
      // use attribute model table_items to generate proper order in the string
      for (let i = 0; i < attributeModel.table_items.length; i++) {
        // add header if it doesn't exist
        if (!headers.includes(attributeModel.table_items[i].attribute)) headers.push(attributeModel.table_items[i].attribute);
        // add individual piece of data to rowData
        rowData[attributeModel.table_items[i].attribute] = data[attributeModel.table_items[i].attribute];
      }
      rows.push(rowData);
    }
    csvString = xlsxUtils.sheet_to_csv(SheetFromArrayOfObjects(rows, headers));
    return csvString;
  }
  return attributeData;
}
